import React, { useEffect } from "react";
import { toast } from "react-toastify";
import usePost from "../../../Hooks/usePost";
import { Domain, Workspace } from "../../../path";
import usePut from "../../../Hooks/usePut";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../../Redux/Action/LoaderAction";
import { useParams } from "react-router-dom";

const Childmodal = ({
  setModalbox,
  Addchild,
  setAddchild,
  Get_ClassDetails,
  Get_otherClassDetails,
}) => {
  const Dispatch = useDispatch();
  const EditChild = usePut(`${Workspace[Domain].API_Path}/add_child`);
  const AddChild = usePost(`${Workspace[Domain].API_Path}/add_child`);
  const Mobile_number_check = usePost(
    `${Workspace[Domain].API_Path}/parent_details`
  );
  const OtherEdit_Child = usePut(
    `${Workspace[Domain].API_Path}/add_child_other`
  );
  const OtherAdd_Child = usePost(
    `${Workspace[Domain].API_Path}/add_child_other`
  );
  const { school_id, class_id } = useParams();
  const CloseModal = () => {
    setAddchild((prev) => ({
      ...prev,
      name: "",
      mobile: "",
      parent_name: "",
      gender: "",
      edit: false,
      child_id: "",
      std: "",
    }));
    setModalbox((prev) => ({ ...prev, addchild: false }));
  };
  const InputHandler = (e) => {
    if (e.target.name === "name" || e.target.name === "parent_name") {
      e.target.value = e.target.value?.replace(/[^A-Za-z ]/, "");
    } else if (e.target.name === "mobile") {
      e.target.value = e.target.value?.replace(/[^0-9]/, "")?.slice(0, 10);
      if (e.target.value?.length == 10) {
        Mobile_number_check.Postcall({
          mobile_number: e.target.value,
        });
      }
    }
    setAddchild((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const SubmitChild = () => {
    if (Addchild?.name == "") {
      toast.warn("Enter Child name");
      toast.clearWaitingQueue();
      return;
    } else if (Addchild?.mobile == "" || Addchild?.mobile?.length < 10) {
      toast.warn("Enter Mobile no");
      toast.clearWaitingQueue();
      return;
    } else if (Addchild?.parent_name == "") {
      toast.warn("Enter parent name");
      toast.clearWaitingQueue();
      return;
    } else if (Addchild?.gender == "") {
      toast.warn("Select gender");
      toast.clearWaitingQueue();
      return;
    }

    if (atob(class_id) != "other") {
      if (Addchild?.edit) {
        EditChild.Putcall({
          child_name: Addchild?.name,
          child_id: Addchild?.child_id,
          parent_name: Addchild?.parent_name,
          child_gender: Addchild?.gender,
        });
      } else {
        AddChild.Postcall({
          child_name: Addchild?.name,
          parent_name: Addchild?.parent_name,
          parent_mobile_no: Addchild?.mobile,
          child_gender: Addchild?.gender,
          class_id: atob(class_id),
        });
      }
    } else {
      if (Addchild?.std == "") {
        toast.warn("Select Standard");
        toast.clearWaitingQueue();
        return;
      }
      if (Addchild?.edit) {
        OtherEdit_Child.Putcall({
          child_name: Addchild?.name,
          parent_name: Addchild?.parent_name,
          parent_mobile_no: Addchild?.mobile,
          child_gender: Addchild?.gender,
          school_id: atob(school_id),
          child_standard: Addchild?.std,
          child_id: Addchild?.child_id,
        });
      } else {
        OtherAdd_Child.Postcall({
          child_name: Addchild?.name,
          parent_name: Addchild?.parent_name,
          parent_mobile_no: Addchild?.mobile,
          child_gender: Addchild?.gender,
          school_id: atob(school_id),
          child_standard: Addchild?.std,
        });
      }
    }
  };
  // INDIVIDUAL EDIT
  useEffect(() => {
    if (EditChild?.Put != null) {
      switch (EditChild?.Put.status) {
        case 200:
          Dispatch(Set_Loader(false));
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          CloseModal();
          toast.success("Changed successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [EditChild?.Put]);
  // INDIVIDUAL ADD
  useEffect(() => {
    if (AddChild?.Post != null) {
      switch (AddChild?.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          CloseModal();
          toast.success("Added successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [AddChild?.Post]);
  // OTHER ADD
  useEffect(() => {
    if (OtherAdd_Child?.Post != null) {
      switch (OtherAdd_Child?.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          CloseModal();
          toast.success("Added successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [OtherAdd_Child?.Post]);
  // OTHER EDIT
  useEffect(() => {
    if (OtherEdit_Child?.Put != null) {
      switch (OtherEdit_Child?.Put.status) {
        case 200:
          Dispatch(Set_Loader(false));
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          CloseModal();
          toast.success("Changed successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [OtherEdit_Child?.Put]);

  // MOBILE NUMBER CHECK
  useEffect(() => {
    if (Mobile_number_check.Post != null) {
      switch (Mobile_number_check.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          setAddchild((prev) => ({
            ...prev,
            parent_name: Mobile_number_check.Post.body[0]?.parent_name,
          }));
          break;

        default:
          break;
      }
    }
  }, [Mobile_number_check.Post]);

  return (
    <div className="fixed w-full h-[100%] top-0 left-0 backdrop-blur-sm bg-[#00000061] flex justify-center items-center">
      <div className="w-[30%] bg-[white] p-3 rounded max-[700px]:w-[95%]">
        <div className="flex items-center justify-between mb-5">
          <h5 className="text-center font-semibold text-lg">Add child</h5>
          <button onClick={CloseModal}>
            <i className="pi pi-times"></i>
          </button>
        </div>
        <div>
          <div className="my-2 w-full">
            <p className="font-semibold text-sm max-[500px]:text-md">
              Child name
            </p>
            <input
              type="text"
              className="border-2 w-full  py-1 px-2 mt-1  text-sm max-[500px]:text-xs"
              placeholder="Enter child name"
              value={Addchild?.name}
              name="name"
              onInput={InputHandler}
            />
          </div>
          <div className="my-2 w-full">
            <p className="font-semibold text-sm max-[500px]:text-md">
              Parent's mobile number
            </p>
            <input
              disabled={Addchild?.edit}
              type="text"
              className="border-2 w-full  py-1 px-2 mt-1  text-sm max-[500px]:text-xs"
              placeholder="Enter mobile number"
              value={Addchild?.mobile}
              name="mobile"
              onInput={InputHandler}
            />
          </div>
          <div className="my-2 w-full">
            <p className="font-semibold text-sm max-[500px]:text-md">
              Parent's name
            </p>
            <input
              type="text"
              className="border-2 w-full  py-1 px-2 mt-1  text-sm max-[500px]:text-xs"
              placeholder="Enter parent name"
              value={Addchild?.parent_name}
              name="parent_name"
              onInput={InputHandler}
            />
          </div>
          {atob(class_id) == "other" ? (
            <div className="my-2 w-full">
              <p className="font-semibold text-sm max-[500px]:text-md">
                Standard
              </p>
              <select
                className="w-full border-2 bg-[white] rounded h-9 outline-none"
                value={Addchild?.std}
                name="std"
                onChange={InputHandler}
              >
                <option value="" disabled>
                  Select Standard
                </option>
                <option value="1">Std I</option>
                <option value="2">Std II</option>
                <option value="3">Std III</option>
                <option value="4">Std IV</option>
                <option value="5">Std V</option>
              </select>
            </div>
          ) : (
            ""
          )}
          <div className="my-2 w-full">
            <p className="font-semibold text-sm max-[500px]:text-md">Gender</p>
            <select
              className="w-full border-2 bg-[white] rounded h-9 outline-none"
              value={Addchild?.gender}
              name="gender"
              onChange={InputHandler}
            >
              <option value="" disabled>
                Select Gender
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
        </div>

        <div className="w-full flex mt-4 items-center justify-center">
          <button
            className="mx-2 bg-[#2da3dc] text-[white] text-sm font-semibold py-1 px-4 rounded"
            onClick={CloseModal}
          >
            Close
          </button>
          <button
            className="mx-2 bg-[#2da3dc] text-[white] text-sm font-semibold py-1 px-4 rounded"
            onClick={SubmitChild}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Childmodal;
